import React, { useState, KeyboardEvent } from 'react';

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  disabled?: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, disabled = false }) => {
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (message.trim() && !disabled) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div style={{
      padding: '1rem',
      borderTop: '1px solid #e1e5e9',
      backgroundColor: 'white',
      borderLeft: 'none'
    }}>
      <div style={{
        display: 'flex',
        gap: '0.5rem',
        alignItems: 'flex-end'
      }}>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Type your message..."
          disabled={disabled}
          rows={1}
          style={{
            flex: 1,
            padding: '12px',
            border: '1px solid #d1d5db',
            borderRadius: '20px',
            resize: 'none',
            fontSize: '14px',
            lineHeight: '1.4',
            minHeight: '44px',
            maxHeight: '120px',
            outline: 'none'
          }}
        />
        <button
          onClick={handleSend}
          disabled={!message.trim() || disabled}
          style={{
            padding: '12px 20px',
            backgroundColor: message.trim() && !disabled ? '#E85D04' : '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '20px',
            cursor: message.trim() && !disabled ? 'pointer' : 'not-allowed',
            fontSize: '14px',
            minWidth: '60px'
          }}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatInput;